import React from "react";

const PoliticalDistricts = ({ politicalDistricts }) => {
  return politicalDistricts ? (
    <React.Fragment>
      <h5>Political Districts</h5>
      <ul className="list-style-none">
        <li>
          <h6>Representative: </h6>
          <span> {politicalDistricts.districtNumber}</span>
        </li>
        <li>
          <h6>Senate: </h6>
          <span> {politicalDistricts.districtNumber}</span>
        </li>
      </ul>
      <ul className="list-style-none"></ul>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <h5>Political Districts</h5>
      <ul className="list-style-none">
        <li>
          <h6>Representative: </h6>
        </li>
        <li>
          <h6>Senate: </h6>
        </li>
      </ul>
      <ul className="list-style-none"></ul>
    </React.Fragment>
  );
};

export default PoliticalDistricts;
